import {
  FormElement
} from "./chunk.UTVDNTSP.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  e,
  n,
  r as r2
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-search-input/jb-search-input.scss?inline
var jb_search_input_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
li, input, :host(.in-search-result) input::placeholder, :host(.in-search-result) input {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host(.in-search-result) input {
  font-size: 31px;
  font-size: 1.9375rem;
  line-height: 42px;
  line-height: 2.625rem;
  appearance: none;
  caret-color: currentcolor;
  height: 42px;
  width: 100%;
}
@media (max-width: 599px) {
  :host(.in-search-result) input {
    font-size: 26px;
    font-size: 1.625rem;
    line-height: 35px;
    line-height: 2.1875rem;
  }
}
:host(.in-search-result) input::-ms-clear {
  display: none;
}
@media (max-width: 599px) {
  :host(.in-search-result) input::placeholder {
    padding-left: 10px;
  }
}
:host(.in-search-result) input:focus {
  outline: none;
}
:host(.in-search-result) section {
  border: 0;
  position: relative;
  z-index: 1;
}
:host(.in-search-result) section > div {
  margin-left: -10px;
  margin-top: -0.5px;
}
@media (min-width: 600px) {
  :host(.in-search-result) section > div {
    margin: 0;
  }
}
:host(.in-search-result) jb-search-icon {
  transform: translate(6px, 1.5px);
}
:host(.in-search-result) ul {
  background: white;
  border-radius: 25px;
  box-shadow: 10px 10px 40px rgba(0, 0, 0, 0.2);
  position: absolute;
  width: 100%;
  z-index: 2;
}
:host(.in-search-result) ul li {
  color: rgb(var(--rgb-primary, 20, 30, 85));
}

:host(.in-search-overlay) {
  display: block;
}
:host(.in-search-overlay) section {
  align-items: center;
  border-bottom: 0;
  display: grid;
  grid-template-columns: 45px 1fr 25px;
  position: relative;
}
:host(.in-search-overlay) section:focus-within::after {
  --stroke-color: #fff;
}
:host(.in-search-overlay) section::after {
  --search-input-border-padding: 0px;
  background-color: var(--stroke-color, rgba(255, 255, 255, 0.2));
  bottom: -22px;
  content: "";
  height: 1px;
  left: var(--search-input-border-padding);
  position: absolute;
  transition: background-color 0.2s ease-in-out;
  width: calc(100% - var(--search-input-border-padding) * 2);
}
@media (min-width: 600px) {
  :host(.in-search-overlay) section::after {
    --search-input-border-padding: 16px;
  }
}
@media (min-width: 960px) {
  :host(.in-search-overlay) section::after {
    --search-input-border-padding: -10px;
  }
}
:host(.in-search-overlay) section > div {
  padding-bottom: 2px;
  padding-left: 2px;
}

:host(:not(.in-search-overlay)) section {
  align-items: center;
  border-bottom: 1px solid var(--stroke-color, rgba(255, 255, 255, 0.2));
  display: grid;
  grid-template-columns: 45px 1fr 25px;
  padding-bottom: 14px;
}
@media (min-width: 600px) {
  :host(:not(.in-search-overlay)) section {
    padding-bottom: 22px;
  }
}

@supports not selector(:has(input)) {
  section {
    border-color: var(--secondary-color, var(--stroke-color, white));
  }
}
section:has(input:focus) {
  border-color: var(--secondary-color, var(--stroke-color, white));
}

jb-search-icon {
  cursor: pointer;
  transform: translateX(var(--search-icon-translate, 0));
}

input {
  appearance: none;
  background: transparent;
  border: none;
  color: var(--fill-color, rgb(var(--rgb-primary, 20, 30, 85)));
  font-size: 1.813rem;
  line-height: 2.188rem;
  width: 100%;
}
input:focus {
  outline: none;
}
input::placeholder {
  color: var(--secondary-color, rgb(var(--rgb-primary, 20, 30, 85)));
}
@media (min-width: 600px) {
  input {
    font-size: 2.063rem;
    line-height: 2.125rem;
  }
}

jb-search-clear-icon {
  height: 23px;
  width: 23px;
}
input:placeholder-shown + jb-search-clear-icon {
  visibility: hidden;
}

jb-search-clear-icon.hidden {
  visibility: hidden;
}

ul {
  color: rgba(55, 55, 55, 0.2);
  left: 0;
  list-style: none;
  margin-top: 1px;
  padding: 40px 15px 20px;
}
@media (min-width: 960px) {
  ul {
    padding-left: 50px;
  }
}

li {
  color: var(--stroke-color, rgb(var(--rgb-primary, 20, 30, 85)));
  cursor: pointer;
  font-size: 1.5rem;
  line-height: 1.875rem;
  padding-bottom: 18px;
}
@media (min-width: 960px) {
  li {
    font-size: 1.75rem;
    line-height: 2.25rem;
    padding-bottom: 0;
    padding-top: 9px;
  }
}

span {
  color: var(--secondary-color, rgba(255, 255, 255, var(--theme-opacity-20, 0.2)));
}`;

// src/components/jb-search-input/jb-search-input.ts
var JbSearchInput = class extends FormElement(h) {
  constructor() {
    super(...arguments);
    this.suggestMode = "auto-suggest";
    this._searchResults = void 0;
    this._selectionIndex = 0;
    this._suggestions = void 0;
  }
  update(changedProperties) {
    super.update(changedProperties);
    if (changedProperties.has("_selectionIndex") && this._selectionIndex && this._suggestions?.length && this._inputElement) {
      this._inputElement.value = this._suggestions[this._selectionIndex - 1];
    }
  }
  focusSearchInput() {
    this._inputElement?.focus();
  }
  _clearInput() {
    if (!this._inputElement) {
      return;
    }
    this._inputElement.value = "";
    this._inputElement.focus();
    this._handleInput();
  }
  _getSuggestMode() {
    if (this.suggestMode === "find-as-you-type") {
      return this.suggestMode;
    }
    return "auto-suggest";
  }
  _goToResult($target) {
    window.open($target.url, "_self");
  }
  _handleInput() {
    if (!this._inputElement || !this.autoSuggestUrl || !this.suggestMode) {
      return;
    }
    this.value = this._inputElement.value;
    const term = this._inputElement.value.trim();
    if (term.length <= 2) {
      this._suggestions = void 0;
      return;
    }
    const url = this.autoSuggestUrl.replace("term", encodeURI(term));
    fetch(url).then((response) => response.json()).then((data) => {
      this._selectionIndex = 0;
      if (this._getSuggestMode() === "auto-suggest") {
        this._suggestions = data.suggestions;
      } else {
        this._searchResults = data.suggestions;
        this._suggestions = Object.keys(data.suggestions[0]);
      }
    });
  }
  _handleKeydown(e2) {
    setTimeout(() => {
      this.value = this._inputElement?.value;
    });
    if (e2.key === "Escape" && this._suggestions?.length) {
      e2.preventDefault();
      this._suggestions = void 0;
      return;
    }
    if (e2.key === "Enter" && this._inputElement?.value) {
      e2.preventDefault();
      this._submit();
      return;
    }
    if ((e2.key === "ArrowDown" || e2.key === "ArrowUp") && this._suggestions?.length) {
      if (e2.key === "ArrowDown") {
        this._selectionIndex = Math.min(this._selectionIndex + 1, this._suggestions?.length || 0);
      }
      if (e2.key === "ArrowUp") {
        this._selectionIndex = Math.max(this._selectionIndex - 1, 0);
      }
      e2.preventDefault();
    }
  }
  _renderSuggestions(renderMode) {
    return this._suggestions?.map((suggestion) => {
      if (!this._inputElement) {
        return "";
      }
      const li = document.createElement("li");
      if (this._selectionIndex === 0) {
        const regEx = new RegExp(this._inputElement.value, "gi");
        li.innerHTML = suggestion.replace(regEx, "<span>$&</span>");
      } else if (this._suggestions[this._selectionIndex - 1] === suggestion) {
        li.innerHTML = `<span>${suggestion}</span>`;
      } else {
        li.innerHTML = suggestion;
      }
      li.addEventListener("click", () => {
        if (this._inputElement) {
          this._inputElement.value = suggestion;
        }
        if (renderMode === "auto-suggest") {
          this._submit();
        } else {
          if (suggestion && this._searchResults) {
            this._goToResult(this._searchResults[0][suggestion]);
          }
        }
      });
      return ke`${li}`;
    });
  }
  _submit() {
    if (!this._inputElement || !this._inputElement.value) {
      return;
    }
    this._suggestions = void 0;
    this.dispatchEvent(
      new CustomEvent("jb-search-input:submit", {
        detail: { value: this._inputElement?.value },
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return ke`
      <section>
        <jb-search-icon @click=${this._submit}></jb-search-icon>
        <div>
          <input
            @input=${this._handleInput}
            @keydown=${this._handleKeydown}
            .placeholder=${this.placeholder}
            type="text"
            .value=${this.value}
          />
        </div>
        ${this.value !== "" ? ke`<jb-search-clear-icon @click=${this._clearInput}></jb-search-clear-icon>` : D}
      </section>
      ${this._suggestions?.length ? ke` <ul>
            ${this._renderSuggestions(`${this.suggestMode}`)}
          </ul>` : D}
    `;
  }
};
JbSearchInput.styles = r(jb_search_input_default);
__decorateClass([
  n()
], JbSearchInput.prototype, "autoSuggestUrl", 2);
__decorateClass([
  n()
], JbSearchInput.prototype, "placeholder", 2);
__decorateClass([
  n()
], JbSearchInput.prototype, "suggestMode", 2);
__decorateClass([
  r2(),
  e("input")
], JbSearchInput.prototype, "_inputElement", 2);
__decorateClass([
  r2()
], JbSearchInput.prototype, "_searchResults", 2);
__decorateClass([
  r2()
], JbSearchInput.prototype, "_selectionIndex", 2);
__decorateClass([
  r2()
], JbSearchInput.prototype, "_suggestions", 2);
JbSearchInput = __decorateClass([
  customElement("jb-search-input")
], JbSearchInput);

export {
  JbSearchInput
};
